<template>
  <router-view/>
</template>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

/* 全局确认框动画 */
.el-message-box {
  transition: all 0.3s ease-in-out;
}

/* 按钮悬停效果 */
.el-button--primary:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}

/* 移动端适配 */
@media (max-width: 768px) {
  .el-message-box {
    width: 80% !important;
  }
}
</style>
